import { config } from './config';

// TODO: Clarify tracking/analytics/marketing script usages

/**
 * Statistic scripts
 */

const appendPiwikTracking = () => {
    const matomoSettings = config.scriptSettings.statistics.tracking.matomo;

    // http://jira.schalk-office.de:8080/browse/SFR-298
    // https://freising.de/                 siteID = 1
    // https://stadtratsportal.freising.de/ siteID = 1
    // https://innenstadt.freising.de/      siteID = 2
    // https://tourismus.freising.de/       siteID = 3


    const u = 'https://statistik.freising.de/';
    // eslint-disable-next-line no-undef
    _paq.push(['setTrackerUrl', `${u}piwik.php`]);
    // eslint-disable-next-line no-undef
    _paq.push(['setSiteId', matomoSettings.key]);
    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.defer = true;
    g.async = true;
    g.src = `${u}piwik.js`;
    s.parentNode.insertBefore(g, s);
};

/**
 * Marketing scripts
 */
// const appendFacebookStuff = () => {
//     return false;
// };

export const appendStatisticScripts = () => {
    appendPiwikTracking();
};

export const appendMarketingScripts = () => {
    // Add marketing scripts here
};
